import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const PlayerActionSpeed = styled.span<React.CSSProperties>`
  color: ${Colors['light']};
  font-family: ${Fonts['regular']};
  font-size: ${30 * Screen.widthRatio}px;
  right: ${70 * Screen.widthRatio}px;
  margin-top: ${8 * Screen.widthRatio}px;
`;

export default PlayerActionSpeed;
